/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

export enum SdsTextSize {
  'Small' = 'sm',
  'Medium' = 'md',
  'Large' = 'lg',
  'ExtraLarge' = 'xlg',
}

export enum SdsTextWeight {
  'Regular' = 'regular',
  'Semibold' = 'semibold',
  'Bold' = 'bold',
}
